const deliveryMethodsEnum = {
  HOME_DELIVERY: 'home_delivery',
  PICK_UP_FROM_STORE: 'pick_up_from_store',
};

export default deliveryMethodsEnum;
